import { Button } from "../Button";

export interface OfflineStateProps {
  title?: string;
  message?: string;
  /** When data is served from cache during the 7-day grace, surface that rather than hard-failing. */
  cached?: boolean;
  onRetry?: () => void;
}

/**
 * OfflineState — one of the 5 mandatory per-screen states (hors-ligne). Local-first modules keep
 * working from cache during the grace window; this communicates the degraded posture.
 */
export function OfflineState({
  title = "Hors ligne",
  message = "La connexion au serveur est interrompue.",
  cached,
  onRetry,
}: OfflineStateProps) {
  return (
    <div className="nv-state nv-state--offline" role="status" aria-live="polite">
      <div className="nv-state__glyph" aria-hidden>
        ⚠
      </div>
      <div className="nv-state__title">{title}</div>
      <p className="nv-state__desc">
        {message}
        {cached ? " Données affichées depuis le cache local." : ""}
      </p>
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          Reconnecter
        </Button>
      )}
    </div>
  );
}
